import { useState, useEffect } from "react";
import { DataService } from "../utils/dataService";
import { datadogLogs } from '@datadog/browser-logs'

export function useUrl(url: string) {
  
  const [uri, setUri] = useState("");

  useEffect(() => {
    const _dataService = new DataService();
    const callLinks = async () => {
      let body = {
        url: url,
        source:"apify"
      };
  
      await _dataService.post("/links", body).then(({ data }) => {
        if (data.success) {
          setUri(data.data.newUrl);
        }
      }).catch((error) => {
        datadogLogs.logger.info('error useEffect', { name: 'post /links', body, error: error.message })
      });
    };
    
    callLinks();
  }, [url]);

  return uri;
}
